import { createReducer } from "redux-orm";
import { combineReducers } from "@reduxjs/toolkit";
import orm from "../models";
import bindSelectors from "../utils/bindSelectors";
import adminMembers, * as fromAdminMembers from "./adminReducer";
import campaigns, * as fromCampaigns from "./campaignReducer";
import categories, * as fromCategories from "./categoryReducer";
import deals, * as fromDeals from "./dealsReducer";
import geoSearchResults, * as fromGeoSearchResults from "./geoSearchReducer";
import * as globalSelectors from "./globalSelectors";
import member, * as fromMember from "./memberReducer";
import offerFilters, * as fromOfferFilters from "./offerFilterReducer";
import program, * as fromProgram from "./programReducer";
import searchResults, * as fromSearchResults from "./searchReducer";
import storeLocation, * as fromStoreLocation from "./storeReducer";
import travel, * as fromTravel from "./travelReducer";
import categoryNav, * as fromCategoryNav from "./categoryNavReducer";

// Redux Toolkit slice reducers
import attractionsReducer from "./attractions/attractionsSlice";
import contactMethodsReducer from "./contactMethods/contactMethodsSlice";
import generalReducer from "./general/generalSlice";
import favorites from "./favorites/favoritesSlice";
import languageReducer from "./language/languageSlice";

// Redux Toolkit selectors
import * as attractionsSelectors from "./attractions/attractionsSelectors";
import * as contactMethodsSelectors from "./contactMethods/contactMethodsSelectors";
import * as generalSelectors from "./general/generalSelectors";
import * as favoritesSelectors from "./favorites/favoritesSelectors";
import * as languageSelectors from "./language/languageSelectors";

export const selectors = {
  ...bindSelectors((state) => state.adminMembers, fromAdminMembers),
  ...bindSelectors((state) => state.member, fromMember),
  ...bindSelectors((state) => state.program, fromProgram),
  ...bindSelectors((state) => state.offerFilters, fromOfferFilters),
  ...bindSelectors((state) => state.deals, fromDeals),
  ...bindSelectors((state) => state.searchResults, fromSearchResults),
  ...bindSelectors((state) => state.geoSearchResults, fromGeoSearchResults),
  ...bindSelectors((state) => state.storeLocation, fromStoreLocation),
  ...bindSelectors((state) => state.categories, fromCategories),
  ...bindSelectors((state) => state, globalSelectors),
  ...bindSelectors((state) => state.travel, fromTravel),
  ...bindSelectors((state) => state.campaigns, fromCampaigns),
  ...bindSelectors((state) => state.favorites, favoritesSelectors),
  ...bindSelectors((state) => state.attractionsReducer, attractionsSelectors),
  ...bindSelectors((state) => state.languageReducer, languageSelectors),
  ...bindSelectors((state) => state.categoryNav, fromCategoryNav),
  ...bindSelectors((state) => state.contactMethodsReducer, contactMethodsSelectors),
  ...bindSelectors((state) => state.generalReducer, generalSelectors),
};

export default combineReducers({
  adminMembers,
  languageReducer,
  member,
  program,
  offerFilters,
  deals,
  searchResults,
  geoSearchResults,
  storeLocation,
  categories,
  travel,
  campaigns,
  favorites,
  attractionsReducer,
  generalReducer,
  categoryNav,
  contactMethodsReducer,
  orm: createReducer(orm),
});
